import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getIntegrations = async (filters) => {
	const { data } = await axios.get(`${API}/admin/integrations/list`, { params: filters });
	return data;
};

export const getIntegration = async (element_id) => {
	const { data } = await axios.get(`${API}/admin/integrations/detail`, { params: { element_id } });
	return data;
};

export const saveIntegration = async (params) => {
	const { data } = await axios.post(`${API}/admin/integrations/save`, params);
	return data;
};

export const importIntegrationExcel = async ({ integration_id, file, db_selected }) => {
	const formData = new FormData();
	formData.append("integration_id", integration_id);
	formData.append("file", file);
	formData.append("db_selected", db_selected ?? "");

	const { data } = await axios.post(`${API}/admin/integrations/import_excel`, formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});

	return data;
};

export const getIntegrationPurchase = async (filters) => {
	const { data } = await axios.get(`${API}/admin/integrations/purchases`, { params: filters });
	return data;
};

export const pendingIntegration = async (params) => {
	const { data } = await axios.post(`${API}/admin/integrations/purchases/pending`, params);
	return data;
};

// Usage
export const getIntegrationUsageLookups = async () => {
	const { data } = await axios.get(`${API}/admin/integrations/usages-lookups`);
	return data;
};

export const getIntegrationUsage = async (filters) => {
	const { data } = await axios.get(`${API}/admin/integrations/usages`, { params: filters });
	return data;
};

export const saveIntegrationParams = async (params) => {
	const { data } = await axios.post(`${API}/admin/integrations/save-params`, params);
	return data;
};

export const resendIntegration = async (params) => {
	const { data } = await axios.post(`${API}/admin/integrations/resend`, params);
	return data;
};

// Sync
export const syncOrders = async (integration) => {
	const { data } = await axios.get(`${API}/admin/${integration}/sync_orders`);
	return data;
};

export const syncOrdersDelivery = async (integration) => {
	const { data } = await axios.get(`${API}/admin/${integration}/sync_orders_delivery`);
	return data;
};

export const syncOrdersSale = async (integration) => {
	const { data } = await axios.get(`${API}/admin/${integration}/sync_orders_sale`);
	return data;
};

export const syncDataFile = async ({ integration, file }) => {
	const formData = new FormData();
	formData.append("file", file);
	const { data } = await axios.post(`${API}/admin/${integration}/sync_data`, formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});
	return data;
};
